import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
export function ForWhomSection() {
  const forWhom = ['Querés una guía clara, no más improvisación', 'Estás dispuesto/a a dedicar 15-20 minutos por día', 'Sabés que algo tiene que cambiar pero no sabés por dónde', 'Convivís con gente que no acompaña y necesitás avanzar igual', 'Valorás la estructura y el orden por encima de la motivación pasajera', 'Querés resultados reales, no promesas vacías'];
  const notForWhom = ['Buscás magia instantánea o soluciones sin esfuerzo', 'No estás dispuesto/a a leer ni aplicar nada', 'Querés que alguien haga el trabajo por vos', 'Esperás promesas de resultados garantizados', 'No creés que tus hábitos influyen en tus resultados', 'Buscás reemplazo de terapia, médico o asesoría profesional'];
  return <section className="py-12 md:py-32 px-4 bg-primary-bg" data-id="element-64">
      <div className="max-w-6xl mx-auto" data-id="element-65">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-12" data-id="element-66">
          <div className="bg-card-bg rounded-2xl md:rounded-3xl p-5 md:p-8 border border-border-gold shadow-md" data-id="element-67">
            <h3 className="font-heading text-xl md:text-2xl lg:text-3xl font-bold text-text-primary mb-5 md:mb-8 flex items-center" data-id="element-68">
              <span className="bg-green-100 text-green-600 p-1.5 md:p-2 rounded-lg mr-3" data-id="element-69">
                <CheckIcon className="w-5 h-5 md:w-6 md:h-6" data-id="element-70" />
              </span>
              Esto ES para vos si...
            </h3>
            <ul className="space-y-3 md:space-y-4" data-id="element-71">
              {forWhom.map((item, idx) => <li key={idx} className="flex items-start" data-id="element-72">
                  <CheckIcon className="w-4 h-4 md:w-5 md:h-5 text-gold shrink-0 mt-0.5 mr-2 md:mr-3" data-id="element-73" />
                  <span className="text-text-secondary text-sm md:text-base font-medium" data-id="element-74">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          <div className="bg-card-bg rounded-2xl md:rounded-3xl p-5 md:p-8 border border-border-gold shadow-sm opacity-90" data-id="element-75">
            <h3 className="font-heading text-xl md:text-2xl lg:text-3xl font-bold text-text-muted mb-5 md:mb-8 flex items-center" data-id="element-76">
              <span className="bg-red-50 text-red-400 p-1.5 md:p-2 rounded-lg mr-3" data-id="element-77">
                <XIcon className="w-5 h-5 md:w-6 md:h-6" data-id="element-78" />
              </span>
              Esto NO es para vos si...
            </h3>
            <ul className="space-y-3 md:space-y-4" data-id="element-79">
              {notForWhom.map((item, idx) => <li key={idx} className="flex items-start" data-id="element-80">
                  <XIcon className="w-4 h-4 md:w-5 md:h-5 text-red-400/70 shrink-0 mt-0.5 mr-2 md:mr-3" data-id="element-81" />
                  <span className="text-text-muted text-sm md:text-base" data-id="element-82">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}